import { DependencyList } from "react";
import { getDataManCallbackOrTypeValue } from "../helpers/getDataManCallbackOrTypeValue";
import { DataManActionCallbackOptions } from "../types/actions";
import { CallbackOrType } from "../types/common";
import { useCancellablePromise } from "./useCancellablePromise";

export function useGetDataManCallbackOrTypeValue<T>(
  value: CallbackOrType<T>,
  options: DataManActionCallbackOptions,
  defaultValue?: T,
  deps?: DependencyList
) {
  return useCancellablePromise(
    async () => await getDataManCallbackOrTypeValue(value, options),
    deps || [value],
    defaultValue || undefined
  );
}
